import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CHAPTER_LEVELS } from '@features/studio/types';

// Фильтры страницы живут в адресе: «назад» из главы возвращает к тем же
// результатам поиска
const querySchema = z.object({
  q: z.string().optional(),
  book: z.string().optional(),
  level: z.enum(CHAPTER_LEVELS).optional(),
  author: z.string().optional(),
});

export const Route = createFileRoute('/curriculum/books/')({
  validateSearch: querySchema,
});
